<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Credores</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Credores',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="E-mail" v-model="dataList.filter.email" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense label="CPF" v-model="dataList.filter.registration" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select no-data-text="Nenhuma informação disponível" dense :items="dataset.status"
                                        label="Status" v-model="dataList.filter.status" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <template>
            <v-row>
                <v-col cols="12" sm="3">
                    <CardItemA icon="mdi-account-group-outline" title="Cadastrados"
                        description="Total de credores cadastrados" :value="summary.total || 'N/A'" />
                </v-col>
                <v-col cols="12" sm="3">
                    <CardItemA icon="mdi-account-badge-outline" title="Ativos" description="Total de credores ativos"
                        :value="summary.active" />
                </v-col>
                <v-col cols="12" sm="3">
                    <CardItemA icon="mdi-account-check-outline" title="Verificados"
                        description="Total de credores verificados" :value="summary.verified || 'N/A'" />
                </v-col>
                <v-col cols="12" sm="3">
                    <CardItemA icon="mdi-account-alert-outline" title="Pendências"
                        description="Total de credores com pendência(s)" :value="summary.pending || 'N/A'" />
                </v-col>
            </v-row>
        </template>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">

                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-card-text>
                            <v-row>
                                <v-col cols="auto" sm="3">
                                    <v-select style="padding-left: 4px;" no-data-text="Nenhuma informação disponível"
                                        dense :items="dataset.status" label="Status" v-model="dataList.filter.status"
                                        item-value="id" item-text="name" outlined hide-details="auto" @change="load">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="6" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense
                                        label="Pesquisar por nome e/ou CPF/CNPJ" v-model="dataList.filter.content"
                                        hide-details outlined clearable @click:clear="clearSearchContent">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-select dense :items="dataset.hasInvalidDocId" label="Doc ID inválido"
                                        v-model="dataList.filter.has_invalid_doc_id" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <template>
                                        <v-tabs @change="load()">
                                            <v-tab @click="setFilterStatus('')">Todos</v-tab>
                                            <v-tab @click="setFilterStatus(1)">Pendências</v-tab>
                                            <v-tab @click="setFilterStatus(2)">Empresa</v-tab>
                                            <v-tab @click="setFilterStatus(3)">Pessoa Fisica</v-tab>
                                        </v-tabs>
                                    </template>
                                </v-col>
                            </v-row>

                            <!-- Filtros rápidos de pendência — visível apenas na aba Pendência -->
                            <v-row v-if="dataList.filter.tabStatus === 1" class="mt-2 ml-1">
                                <v-col cols="auto" class="d-flex align-center" style="gap: 8px;">
                                    <span class="caption grey--text">Pendências:</span>

                                    <v-chip
                                        :color="dataList.filter.pending_type === '' ? 'primary' : 'grey lighten-2'"
                                        :text-color="dataList.filter.pending_type === '' ? 'white' : 'black'"
                                        small
                                        @click="setPendingFilter('')"
                                    >
                                        Todas
                                    </v-chip>

                                    <v-chip
                                        :color="dataList.filter.pending_type === 'account' ? 'warning' : 'grey lighten-2'"
                                        :text-color="dataList.filter.pending_type === 'account' ? 'white' : 'black'"
                                        small
                                        @click="setPendingFilter('account')"
                                    >
                                        <v-icon left x-small>mdi-account-alert</v-icon>
                                        Conta
                                    </v-chip>

                                    <v-chip
                                        :color="dataList.filter.pending_type === 'representative' ? 'warning' : 'grey lighten-2'"
                                        :text-color="dataList.filter.pending_type === 'representative' ? 'white' : 'black'"
                                        small
                                        @click="setPendingFilter('representative')"
                                    >
                                        <v-icon left x-small>mdi-account-tie</v-icon>
                                        Representante
                                    </v-chip>

                                    <v-chip
                                        :color="dataList.filter.pending_type === 'lawyer' ? 'warning' : 'grey lighten-2'"
                                        :text-color="dataList.filter.pending_type === 'lawyer' ? 'white' : 'black'"
                                        small
                                        @click="setPendingFilter('lawyer')"
                                    >
                                        <v-icon left x-small>mdi-gavel</v-icon>
                                        Procurador
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum usuário foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.name`]="{ item }">
                                <v-avatar :size="30">
                                    <img :src="'https://ui-avatars.com/api/?name=' + item.name" />
                                </v-avatar>
                                <span class="ml-4 list-item-title">{{ item.name }}</span><br />
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="item.status == 0 ? 'accent' : 'error'" label text-color="white" small>
                                    {{ item.status | enum(dataset.status, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.account_verified_at`]="{ item }">
                                <v-chip
                                    :color="item.account_verified_at !== '0000-00-00 00:00:00' ? 'accent' : 'warning'"
                                    label text-color="white" small>
                                    {{ item.account_verified_at !== '0000-00-00 00:00:00' ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.pending`]="{ item }">
                                <v-chip v-if="!item.has_pending_items" color="accent" label text-color="white" small>
                                    NÃO
                                </v-chip>

                                <v-tooltip v-else bottom color="grey darken-4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-chip v-bind="attrs" v-on="on" color="warning" label text-color="white" small>
                                            SIM
                                            <v-icon right x-small>mdi-alert-circle-outline</v-icon>
                                        </v-chip>
                                    </template>

                                    <div class="py-1">
                                        <div class="mb-2"
                                            style="border-bottom: 1px solid #777; font-weight: bold; font-size: 12px">
                                            PENDÊNCIA:
                                        </div>

                                        <template v-for="(value, key) in item.pending_items">
                                            <div v-if="value === true" :key="key" class="d-flex align-center mb-1">
                                                <v-icon color="orange lighten-2" x-small
                                                    class="mr-2">mdi-close-octagon</v-icon>
                                                <span class="white--text" style="font-size: 11px">
                                                    {{ dataset.pendingLabels[key] || key }}
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </v-tooltip>
                            </template>

                            <!-- <template v-slot:[`item.pending`]="{ item }">
                                <v-chip :color="item.has_pending_items ? 'warning' : 'accent'" label text-color="white"
                                    small>
                                    {{ item.has_pending_items ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template> -->

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon v-if="!$check(user, ['users.update'])" :disabled="!$check(user, ['users.find'])"
                                    @click="viewItem(item)" size="large" class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['users.update']))" @click="viewItem(item)"
                                    size="large" class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import status from "@/common/data/user-status.data";
import userTypes from "@/common/data/user-types.data";

import CardItemA from "@/layouts/components/CardItemA";
//import CardItemB from "@/layouts/components/CardItemB";

Vue.use(VueLodash)

export default {
    name: "UserList",

    components: {
        CardItemA,
    },

    data: () => ({
        user: null,
        summary: {
            total: null,
            active: null,
            verified: null,
            pending: null
        },
        dataset: {
            status: [{ id: "", name: "Todos" }, ...status],
            hasInvalidDocId: [{ id: "", name: "Todos" }, { id: 1, name: "SIM" }, { id: 2, name: "NÃO" }],
            userTypes: userTypes,
            clients: [],
            units: [],
            data: {},
            pendingLabels: {
                user_representatives: "Representante da empresa",
                lawyer_users: "Associação com procurador",
                user_account: "Conta do usuário"
            },
        },
        dataList: {
            filter: {
                content: "",
                status: "",
                has_invalid_doc_id: "",
                tabStatus: "",
                pending_type: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "E-mail", value: "email" },
                { text: "Status", value: "status" },
                { text: "Verificado", value: "account_verified_at" },
                { text: "Pendência", value: "pending" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        //this.load();
        this.loadSummary();
    },

    methods: {
        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.dataList.filter.has_invalid_doc_id = "";
            this.load();
        },

        clearSearchContent() {
            this.dataList.filter.content = "";
            this.load();
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        setFilterStatus(value) {
            this.dataList.filter.tabStatus = value;
            // Limpa o filtro de pendência ao trocar de aba
            if (value !== 1) {
                this.dataList.filter.pending_type = '';
            }
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            //console.log(this.dataList.filter)

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/admin/users', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            window.open(`#/credores/${item.id}`);
            //this.$router.push(`credores/${item.id}`);
        },

        async loadSummary() {

            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/admin/users/summary-count');

                const content = result && result.data && result.data.content                    
                    ? result.data.content
                    : null;

                if (!content || Object.keys(content).length === 0) {
                this.summary = {
                    total: 0,
                    active: 0,
                    verified: 0,
                    pending: 0
                };
                return;
                }

                this.summary = content;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },

        setPendingFilter(value) {
            if (this.dataList.filter.pending_type === value) {
                this.dataList.filter.pending_type = '';
            } else {
                this.dataList.filter.pending_type = value;
            }
            this.load();
        },
       
    },
};
</script>